// src/experimentals/chart-colors.mjs

/**
 * @type {Experiment}
 */
export const ChartColorsExperiment = {
  id: 'chart-colors',
  type: 'chart-styling',
  name: 'Flerfarvede gentagelser',
  exclusive: false,          // Tillader at køre sammen med andre styling-eksperimenter
  allowMultiple: false, // 🚨 Tillader eksplicit IKKE at køre flere gange!
  
  /**
   * @param {AppState} appState 
   * @returns {void}
   */
  init(appState) {

    console.log(`[Eksperiment] ${ChartColorsExperiment.name}...`);

    // Registrer en modifier til at transformere arrayet af datasets
    appState.registerModifier('chart:datasets', 
      /**
       * @param {import('chart.js').ChartDataset<'bar'>[]} datasets
       * @returns {import('chart.js').ChartDataset<'bar'>[]}
       */
      (datasets) => {
        const palette = appState.palette;
        return datasets.map((dataset, index) => {
          // datasetIndex 0 er det primære datasæt – det springer vi over
          if (index === 0) {
            return dataset; 
          }

          // Tilføj eller overskriv radius-egenskaberne direkte på det sekundære datasæt
          return {
            ...dataset,
            backgroundColor: palette[(index % palette.length) - 1],
            hoverBackgroundColor: palette[(index % palette.length) - 1].replace('0.5', '0.8')
          };
        });
      });
  }
};